module.exports = __webpack_public_path__ + "static/media/shapes_story.3c38cf1f.png";